import { useContext, useState } from "react";
import { OrganizationContext, useTranslation } from "hhn-commons";
import { SearchBox } from "../../common/SearchBox";
import {
  AddGroupListContainer,
  SearchAndFilterContainer,
} from "../AddMember.style";
import GroupsList from "./GroupsList";

type AddGroupType = {
  tabValue: number;
};

const AddGroupList = ({ tabValue }: AddGroupType) => {
  useContext(OrganizationContext);

  const { t } = useTranslation();
  const tNChat = (key: string) => t(key, { ns: "chat" });
  const [searchText, setSearchText] = useState<string>("");

  const onSearchTextChange = async (text: string) => {
    setSearchText(text);
  };

  const onSearchClear = async () => {
    setSearchText("");
  };

  return (
    <AddGroupListContainer>
      <SearchAndFilterContainer>
        <SearchBox
          searchText={searchText || ""}
          onSearchTextChange={onSearchTextChange}
          placeholderLabel={tNChat("search")}
          onSearchClear={onSearchClear}
          tabValue={tabValue}
        />
      </SearchAndFilterContainer>

      <GroupsList searchText={searchText} />
    </AddGroupListContainer>
  );
};

export default AddGroupList;
